import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {Button, Tooltip, Typography} from '@mui/material';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Link, useNavigate} from 'react-router-dom';
import Box from "@mui/material/Box";
import DateRangeFilter from "../../../../filter/DateRangeFilter";
import DateTimeUtil from "../../../../../../utils/common/DateTimeUtil";
import ModalConfirm from "../../../../modal/ModalConfirm";
import CreateNewOrderModal from "./CreateNewOrderModal";
import CustomerOrderService from "../../../../../../API/orders/orders/customer/CustomerOrderService";
import {customerOrderType} from "../../../../../../data/CustomerOrderType";
import ButtonCreate from "../../../../button/ButtonCreate";
import MenuItem from "@mui/material/MenuItem";
import selectionTableUtil, {normalizeSelection} from "../../../../../../utils/common/SelectionTableUtil";
import {webSocketPath} from "../../../../../../Constants";
import CircularProgress from "@mui/material/CircularProgress";
import {CircularProgressWithLabel} from "../../../../circularProgress/CircularProgressWithLabel";

const CustomerUpload3DModelTable = ({
                                        archive,
                                        data,
                                        setData,
                                        createType,
                                        rowSelection,
                                        setRowSelection,
                                        handleModalAlert,
                                        tableOptions,
                                        tableOptionsHandle,
                                        orderId,
                                        nameOrder,
                                        year
                                    }) => {
    const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
    const currentSelection = normalizeSelection(rowSelection)

    useEffect(() => {
        // Создаём WebSocket-соединение
        // Если нужно передать токен или ID для сессии, добавьте в URL: `ws://localhost:3900/convert-status-update?token=your_token&sessionId=123`
        const ws = new WebSocket(`${webSocketPath}/convert-status-update`);
        let currentData = data
        // Обработчик открытия соединения (handshake)
        ws.onopen = (event) => {
            console.log('WebSocket подключён:', event); // Добавьте event для деталей
            // Здесь можно отправить сообщение бэкенду для инициации сессии, если нужно
            ws.send('init_session');
        };

        // Обработчик входящих сообщений
        ws.onmessage = (event) => {
            try {
                const socketData = JSON.parse(event.data); // Парсим JSON в объект

                if (currentData.some(el => el.id === socketData.id)) {
                    const newData = currentData.map(el => el.id === socketData.id ? socketData : el)
                    setData(newData)
                    currentData = newData
                } else {
                    const newData = [...currentData, socketData]
                    tableOptionsHandle((prev) => ({...prev, totalElements: newData.length}))
                    setData(newData)
                    currentData = newData
                }
            } catch (error) {
                console.error('Ошибка парсинга JSON:', error);
            }
        };

        // Обработчик ошибок (здесь часто видны проблемы с сессией)
        ws.onerror = (error) => {
            console.error('WebSocket ошибка:', error); // Логируйте event, если доступно
            // Возможные причины: неверный URL, бэкенд не отвечает, CORS
        };

        // Обработчик закрытия
        ws.onclose = (event) => {
            console.log('WebSocket закрыт:', event.code, event.reason); // Добавьте code/reason для деталей (например, 1006 — abnormal close)
            // Если сессия не создана, возможно, бэкенд закрывает соединение сразу
        };

        // Очистка при размонтировании компонента
        return () => {
            console.log('Закрываем WebSocket при размонтировании');
            ws.close();
        };
    }, []); //

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: ' filename',
                header: 'Имя файла',
                accessorKey: 'filename',
                size: 40,
            },
            {
                accessorFn: (row) => {
                    if (row.dateTimeOfCreate === null) {
                    } else {
                        return new Date(row.dateTimeOfCreate)
                    }
                },
                id: 'dateTimeOfCreate',
                header: 'Дата создания',
                size: 300,
                sortingFn: 'datetime',
                Cell: ({cell}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? '' : DateTimeUtil.dateTimeToString(value);
                },
                filterFn: (row, id, filterValue) => {
                    const startDate = filterValue?.startDate;
                    const endDate = filterValue?.endDate;
                    if (startDate && endDate) {
                        return (
                            DateTimeUtil.checkDateBefore(row.getValue(id), startDate) &&
                            DateTimeUtil.checkDateAfter(row.getValue(id), endDate)
                        );
                    }
                    return true;
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                accessorFn: (row) => {
                    if (row.dateTimeFinish === null) {
                    } else {
                        return new Date(row.dateTimeFinish)
                    }
                },
                id: 'dateTimeFinish',
                header: 'Дата завершения',
                size: 300,
                sortingFn: 'datetime',
                Cell: ({cell}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? '' : DateTimeUtil.dateTimeToString(value);
                },
                filterFn: (row, id, filterValue) => {
                    const startDate = filterValue?.startDate;
                    const endDate = filterValue?.endDate;
                    if (startDate && endDate) {
                        return (
                            DateTimeUtil.checkDateBefore(row.getValue(id), startDate) &&
                            DateTimeUtil.checkDateAfter(row.getValue(id), endDate)
                        );
                    }
                    return true;
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },
            {
                id: 'percentageOfCompletion',
                header: 'Процент обработки',
                accessorKey: 'percentageOfCompletion',
                size: 40,
                Cell: ({cell}) => {
                    const value = cell.getValue();
                    return <Box
                        sx={{display: "flex", justifyContent: "center", padding: "10px"}}>
                        <CircularProgressWithLabel value={value}/>
                    </Box>
                },
            },
            {
                id: 'messagesSize',
                header: 'Количество сообщений/ошибок',
                accessorKey: 'messagesSize',
                size: 40,
                Cell: ({cell, row}) => {
                    const value = cell.getValue()
                    return value > 0 ? <Link
                        to={`/customer/orders/${orderId}/${nameOrder}/${year}/messages/${row.original.id}`}>{value}</Link> : value
                }
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableEditing: false,
            },
        ];

        return baseColumns;

    }, [data, setData]);

    return (
        <Box sx={{maxWidth: "1800px"}}>
            <Box
                sx={{display: 'flex', justifyContent: "space-between", paddingBottom: "8px"}}
            ><
                Typography sx={{fontSize: "24px", fontWeight: 700}}>Импорты</Typography>
            </Box>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                selectAllMode={"all"}
                enableColumnFilterModes
                enableGrouping={false}
                enableStickyHeader={false}
                enablePinning={false}
                // muiTableProps={{
                //     sx: {
                //         tableLayout: 'fixed',
                //     },
                // }}
                muiTableBodyCellProps={{
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        border: "none",
                        "& td:after": {
                            "&:hover": {
                                backgroundColor: "red"
                            }
                        },
                        "&:not(:last-of-type)": {
                            borderRight: '1px solid #EAEBEA',

                        },

                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }

                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem"
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",

                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "& td:after": {
                                    display: "none",
                                },
                            },
                            '&:nth-of-type(even)': {
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light
                                },
                            },
                        })
                    })
                }}
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 3,
                        minSize: 3,
                        grow: false,
                    },
                    'mrt-row-select': {
                        size: "50px",
                        grow: false,
                    },
                }}
                columns={columns}
                data={data}
                onRowSelectionChange={onRowSelectionChange}
                state={{rowSelection: currentSelection, showGlobalFilter: true, pagination: tableOptions}}
                getRowId={(originalRow) => originalRow.id}
                selectionPadding={1}
                selectionCss={{
                    backgroundColor: 'lightblue',
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: 'blue',
                    borderRadius: '4px',
                }}
                initialState={{
                    columnVisibility: {
                        id: false,
                        model: false,
                        year: false,
                    },
                    isFullScreen: false,
                    density: "compact",
                }}
                muiToolbarAlertBannerChipProps={{color: 'primary'}}
                localization={MRT_Localization_RU}
                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                rowCount={tableOptions.totalElements}
                enableRowSelection={false}
                enableRowActions={false}
                enableToolbarInternalActions={false}
            />
        </Box>
    );
};

export default CustomerUpload3DModelTable;